<template>
  <div style="height: 100%;background-color: #333;">
    <div class="view-content"
         ref="content">
      <video ref="video"
             autoplay
             playsinline
             controls>
      </video>
    </div>
    <div class="view-navbar">
      <ul class="clear-both"
          ref="view-list"
          :style="{width:`${ulWidth}px`, transform: `translateX(${ulTransform}px)`}">
        <li :class="viewIndex===index?'active':''"
            v-for="({cover}, index) in files"
            :key="index+cover"
            @click="view(index)">
          <img :src="cover|ossHost(suffix)"
               :alt="cover">
        </li>
      </ul>
    </div>
    <template>
      <button ref="videoRotate"
              type="button"
              class="plyr__control"
              @click="onRotate">
        <svg role="presentation">
          <use xlink:href="#plyr-restart"></use>
        </svg>
        <span class="plyr__tooltip"
              role="tooltip">旋转90°</span>
      </button>
    </template>
    <template>
      <a ref="resDownload"
         class="plyr__controls__item plyr__control"
         href=""
         target="_blank"
         data-plyr="download"
         download
         @click.prevent="onDownload">
        <svg role="presentation"
             focusable="false">
          <use xlink:href="#plyr-download"></use>
        </svg>
        <span class="plyr__tooltip">下载</span></a>
    </template>
  </div>
</template>

<script>
import download from 'downloadjs'
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'
// https://github.com/sampotts/plyr

let player = null

export default {
  mixins: [],
  components: {},
  props: {
    files: {
      type: Array,
      default: () => {
        return []
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      viewIndex: 0,
      liWidth: 60,
      ulTransform: 0,
      suffix: '?x-oss-process=image/resize,m_pad,h_55,w_55,color_FFFFFF'
    }
  },
  computed: {
    ulWidth () {
      return this.liWidth * this.files.length
    },
    file () {
      return this.files[this.viewIndex]
    },
  },
  watch: {
    visible (val) {
      if (val) {
        this.view(this.index)
      } else {
        player.pause()
      }
    },
  },
  created () {
    this.$nextTick(() => {
      this.view(this.index)
    })
  },
  mounted () {
    player = new Plyr(this.$refs.video, {
      tooltips: {controls: true},
      volume: 10,
      disableContextMenu: false,
      controls: [
        'play-large',
        // 'restart',
        // 'rewind',
        'play',
        // 'fast-forward',
        'progress',
        'current-time',
        'mute',
        'volume',
        // 'captions',
        'settings',
        'pip',
        'airplay',
        // 'download',
        'fullscreen',
      ],
      i18n: {
        play: '播放',
        pause: '暂停',
        mute: '静音',
        unmute: '取消静音',
        download: '下载',
        enterFullscreen: '全屏',
        exitFullscreen: '退出全屏',
        pip: '画中画',
        settings: '设置',
        speed: '速度',
        normal: '正常',
      },
    })
    player.on('ready', event => {
      player.rotateAngle = 0
      $('.plyr__controls', this.$el).append(this.$refs.videoRotate)
      $('.plyr__menu', this.$el).append(this.$refs.resDownload)
    })
  },
  destroyed () {
    player.destroy()
  },
  methods: {
    view (index) {
      this.viewIndex = index
      this.transform()
      this.$nextTick(() => {
        this.ratio()
        player.source = {
          type: 'video',
          sources: [
            {
              src: filter.ossConvertMP4(this.file.src),
              type: 'video/mp4',
            },
            {
              src: filter.ossHost(this.file.src),
              type: 'video/mp4',
            }
          ],
          poster: this.file.cover,
        }
        this.$refs.resDownload.href = filter.ossHost(this.file.src)
        player.play()
      })
    },
    transform () {
      this.ulTransform = (this.$el.offsetWidth - this.liWidth) / 2 - this.liWidth * this.viewIndex
    },
    onDelete () {
      let {files, viewIndex} = this
      if (files.length > 1) {
        files.splice(viewIndex, 1)
        this.view(this.viewIndex)
      }
    },
    onRotate () {
      // 顺时针旋转90°
      player.rotateAngle += 90
      // 重置旋转角度
      if (player.rotateAngle === 360) {
        player.rotateAngle = 0
      }
      let video = $('video', this.$el)
      // 需要旋转
      if (player.rotateAngle) {
        let width = video.width()
        let height = video.height()
        // 旋转后需要偏移位置
        let translate = ''
        if (player.rotateAngle === 90) {
          translate = `translate(${width}px)`
        }
        if (player.rotateAngle === 180) {
          translate = `translate(${height}px, ${width}px)`
        }
        if (player.rotateAngle === 270) {
          translate = `translate(0px, ${height}px)`
        }
        // 实现旋转
        video.css({
          width: height + 'px',
          height: width + 'px',
          transform: `${translate} rotate(${player.rotateAngle}deg)`,
          transformOrigin: 'left top',
        })
      } else {
        video.removeAttr('style')
      }
    },
    ratio () {
      player.ratio = `${$(this.$refs.content).width()}:${$(this.$refs.content).height()}`
    },
    onDownload () {
      // 替换掉 http, 防止出现 https 向 http 请求的错误
      download(filter.ossHost(this.$refs.resDownload.href))
    },
  },
}
</script>

<style lang="scss">
.view-content {
  .plyr--video {
    height: 100%;
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
.view-content {
  height: calc(100% - 57px);
  position: relative;
}

.view-navbar {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
  background-color: rgba(0, 0, 0, .95);
  overflow: hidden;

  ul {
    transform: translateX(0px);
    margin: 10px 0px;
    transition: all 0.3s;
    box-sizing: content-box;
    height: 55px;
    margin: 0;
    overflow: hidden;
    padding: 1px 0;

    li {
      &.active {
        opacity: 1;
      }

      float: left;
      list-style: none;
      width: 55px;
      height: 55px;
      margin-right: 5px;
      background-color: #fff;
      color: transparent;
      cursor: pointer;
      float: left;
      font-size: 0;
      line-height: 0;
      opacity: 0.5;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/AnswerFileFullScreen/src/ViewVideo.vue